import type { FaireProductEntity } from "../../entity_types/product";

export const p_s5c6djgtkt: FaireProductEntity = {
  token: "p_s5c6djgtkt",
  type: "product",
  name: "Butterfly Pea Flower-No Labels",
  brandToken: "b_xvt273bhwc",
  brandName: "Herbal Rose Apothecary",
  imageUrl:
    "https://cdn.faire.com/fastly/36b715bcfa459a2f3df33ab11c8efdd615ffd8d06f619669d8620934fe733dc8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c5a7d8cbbffdea6f5d5a66cd2aac248ae44a20d2bdbc1b501526dcdc61c18b4d.jpeg",
  ],
  priceDollars: 5.2,
  description:
    'Butterfly pea flower is often referred to as the "mood ring cocktail" due to its color changes related to pH balances. Often mixed with hibiscus, honey, mint, cinnamon, passion fruit or ginger. Often used as a natural food color additive, herbal teas, soaps, shampoos, facial masks, scrubs and other beauty products. Perfect for beginner-friendly apothecaries, workshops, metaphysical shops, spiritual boutiques, and holistic retailers. Most shops stock 4–6 units to start & reorder monthly.\n\n✔ White Label Ready – No labels, perfect for custom branding & private labeling.\n✔ Versatile Uses – Ideal for apothecary uses (herbal tea, infused oils, tinctures, lotions), and also spell jars, candle magic, anointing, and more.\n✔ Premium Quality – Carefully selected for potency and freshness.\n✔ Retail-Ready Packaging – Resealable bags for easy display.\n\n*No labels on products, you add your own labels and branding to products.\n\n\nAvailable in plastic resealable bags designed to keep out moisture in a variety of sizes. All herbs are ethically/organically sourced. \n\nDried butterfly pea flower whole\nOrigin: India',
  tags: [],
  msrpDollars: 11.02,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:55.481Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
